import {API_DRIVER} from "../config/axios";
import {WishType} from "../store/wish/Helper";

export interface ICategoryCreateEdit {
    name_en: string
    name_mk: string
    name_al: string
    show_when_empty: boolean
}

interface IFetchCategoriesWithCounts {
    wish_type?: WishType
    include_empty?: boolean
}

const getCategoriesRequestUrl = (endpointUrl: string) => {
    return `/api/categories${endpointUrl}`
}

const CategoryService = {
    fetchCategoriesWithCounts: (params: IFetchCategoriesWithCounts) => {
        return API_DRIVER.get(getCategoriesRequestUrl(''), {
            params: {...params}
        })
    },
    createCategory: (category: ICategoryCreateEdit) => {
        return API_DRIVER.post(getCategoriesRequestUrl(''), category)
    },
    updateCategory: (id: string, body: ICategoryCreateEdit) => {
        return API_DRIVER.put(getCategoriesRequestUrl(`/${id}`), body)
    },
    deleteCategory: (categoryId: string) => {
        return API_DRIVER.delete(getCategoriesRequestUrl(`/${categoryId}`))
    }
}

export default CategoryService
